import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";
import Tooltip from "@atlaskit/tooltip";

import { UnreadIndicator } from "./unread-indicator";

const indicatorButtonStyles = css({
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "border": `${token("border.width.0")} solid transparent`,
    "background": "transparent",
    "padding": token("space.050"),
    "cursor": "pointer",
    "width": "32px",
    "height": "32px",
    "marginLeft": token("space.050"),
    "flexShrink": 0,
    "borderRadius": token("border.radius.circle"),
    "outline": "none",
    "&:hover": {
        backgroundColor: token("color.background.neutral.subtle.hovered")
    },
    "&:focus": {
        boxShadow: `0 0 0 2px ${token("color.border.focused")}`
    },
    "&:active": {
        backgroundColor: token("color.background.selected")
    }
});

const cardHoveredStyles = css({
    boxShadow: `0 0 0 1px var(--ds-border, rgba(9, 30, 66, 0.08))`
});

export interface ReadStateIndicatorProps {
    isRead: boolean;
    onToggle: () => void;
    testId?: string;
    isCardHovered?: boolean;
}

export const ReadStateIndicator = ({
    isRead,
    onToggle,
    testId,
    isCardHovered = false
}: ReadStateIndicatorProps) => {
    const label = isRead ? "Mark as unread" : "Mark as read";

    return (
        <Tooltip content={label} position="top">
            <button
                css={[
                    indicatorButtonStyles,
                    isCardHovered && cardHoveredStyles
                ]}
                type="button"
                onClick={onToggle}
                data-testid={testId || "read-state-indicator"}
                aria-label={label}
                aria-pressed={!isRead}
            >
                <UnreadIndicator
                    fillColour={
                        isRead ? "transparent" : token("color.icon.brand")
                    }
                />
            </button>
        </Tooltip>
    );
};
